<template>
  <div :class="['v-modal']" ref="vModal">
    <v-dialog v-model="dialog" :class="modalType" style="z-index: 10000" attach @input="close">
      <!-- 个人中心登录 -->
      <login-in v-if="modalType === 'loginIn'" />
      <!-- 登录个人中心 -->
      <regist v-if="modalType === 'regist'" />
      <!-- 设置个人资料 -->
      <set-up-account v-if="modalType === 'setUpAccount'" />
      <!-- 添加收藏夹 -->
      <add-favorites v-if="modalType === 'addFavorites'" />
      <!-- 编辑收藏夹 -->
      <edit-favorites v-if="modalType === 'editFavorites'" />
      <!-- 取消收藏提示 -->
      <cancel-favorite v-if="modalType === 'cancelFavorite'" />
      <!-- 删除收藏夹提示 -->
      <remove-favorite v-if="modalType === 'removeFavorite'" />

      <v-btn class="close-btn" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-dialog>

    <!-- 创建收藏夹 -->
    <v-dialog v-model="$store.state.vModal.isCreateFavoriteDialogShow" class="create-favorites-name" style="z-index: 10020" attach @input="close_favorite_dialogs">
      <!-- 创建收藏夹名称 -->
      <createFavorites @close="close_favorite_dialogs" ref="createFavorites" />
      <v-btn class="close-btn" @click="close_favorite_dialogs">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-dialog>
  </div>
</template>

<script>
import { timeout } from "@/utils/util.js";
// 弹框库
import loginIn from "@/components/modal-components/login-in";
import addFavorites from "@/components/modal-components/add-favorites";
import createFavorites from "@/components/modal-components/create-favorites";
import editFavorites from "@/components/modal-components/edit-favorites";
import cancelFavorite from "@/components/modal-components/cancel-favorite";
import removeFavorite from "@/components/modal-components/remove-favorite";
import setUpAccount from "@/components/modal-components/set-up-account";
import regist from "@/components/modal-components/regist";

export default {
  name: "v-modal",

  data() {
    return {
      dialog: false,
      modalType: "",
      isCreateFavorites: false,
    };
  },
  components: {
    loginIn,
    addFavorites,
    createFavorites,
    editFavorites,
    cancelFavorite,
    removeFavorite,
    setUpAccount,
    regist,
  },
  computed: {
    vModalShow() {
      return this.$store.state.vModal.showType;
    },
  },
  watch: {
    vModalShow() {
      this.modalType = this.$store.state.vModal.showType;
      this.dialog = this.modalType !== "" ? true : false;
    },
  },
  created() {
    this.$P.$on("closeModal", () => {
      this.close();
    });
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    async close() {
      this.dialog = false;
      await timeout(300);
      this.$store.state.vModal.showType = "";
    },

    async close_favorite_dialogs() {
      this.$store.state.vModal.isCreateFavoriteDialogShow = false;
      this.$refs.createFavorites.reset();
    },
  },
};
</script>

<style lang="scss">
.v-modal {
  .v-dialog {
    padding: 16px;
  }
  .close-btn {
    position: absolute;
    right: 2px;
    top: 4px;
    width: 32px;
    height: 32px;
    border-radius: 50%;

    i {
      font-size: 22px;
    }
  }

  h3 {
    font-size: 20px;
  }
}

.create-favorites-name {
  .v-dialog {
    width: 480px;
  }
}
</style>
